/** @format */

import {
	AppProductReviewState,
	ReviewService,
	ReviewSummary,
	selectAIReviewSummary,
	selectProductReviewProductIdentifier,
	selectProductReviewSummary,
	setReviewAISummary
} from '@product-reviews/data-access';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { Subject, takeUntil, Observable, switchMap } from 'rxjs';

import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ReviewAISummaryResponse } from '@shared/data-access/interfaces';
import { Store } from '@ngrx/store';
import { homefieldIconAiStar, HomefieldIconLibraryModule, HomefieldIconsLibraryService } from '@dsg-tech/homefield-angular-icons';

@Component({
    selector: 'product-reviews-ai-summary',
    imports: [
        CommonModule,
        HomefieldIconLibraryModule
    ],
    templateUrl: './review-ai-summary.component.html',
    styleUrl: './review-ai-summary.component.scss'
})
export class ReviewAISummaryComponent implements OnInit, OnDestroy {
	private readonly UNSUBSCRIBE$ = new Subject<void>();

	selectProductId$: Observable<string> = this.store.select(selectProductReviewProductIdentifier);
	reviewAISummary: string;
	totalReviews: number;

	constructor(
		private readonly homefieldIconsLibraryService: HomefieldIconsLibraryService,
		private readonly store: Store<AppProductReviewState>,
		private readonly reviewSvc: ReviewService,
		@Inject(PLATFORM_ID) private readonly platformId
	) {
		this.homefieldIconsLibraryService.registerIcons([
			homefieldIconAiStar
		]);
	}

	ngOnInit() {
		if (isPlatformBrowser(this.platformId)) {
			this.store.select(selectAIReviewSummary)
				.pipe(takeUntil(this.UNSUBSCRIBE$))
				.subscribe((aiSummary: ReviewAISummaryResponse) => {
					if (aiSummary.summary) {
						this.reviewAISummary = aiSummary.summary;
					}
				});

			this.store.select(selectProductReviewSummary)
				.pipe(takeUntil(this.UNSUBSCRIBE$))
				.subscribe((reviewSummary: ReviewSummary) => {
					this.totalReviews = reviewSummary.reviewCount ?? 0;
				});

			this.selectProductId$.pipe(
					takeUntil(this.UNSUBSCRIBE$),
					switchMap((productID: string) => this.reviewSvc.getAIReviewSummary$(productID))
				).subscribe((resp:ReviewAISummaryResponse) => {
					this.store.dispatch(setReviewAISummary({aiReview: resp}));
				});
		}
	}

	ngOnDestroy(): void {
		this.UNSUBSCRIBE$.next();
		this.UNSUBSCRIBE$.complete();
	}
}